import BaseHttpService from "../baseService";

class FinancialServiceProvider extends BaseHttpService {
	constructor() {
		super("financials");
	}

	/**
	 * Load my rial and baazar credit
	 *
	 * @async
	 * @version 1.0.0
	 */
	public myCredit(): HttpService.BaseResponse<Account.AccountCredits> {
		return this.getResource().get("my-credit");
	}

	/**
	 * Buy gold by credit
	 *
	 * @async
	 * @version 1.0.0
	 */
	public buyGold(data: object): HttpService.BaseResponse<Wallet.BuyAsset> {
		return this.dynamicMakeResource("financials", "v2").post("buy-baazar", data);
	}

	public sellGold(data: Financials.SellRequest): HttpService.BaseResponse<any> {
		return this.dynamicMakeResource("financials", "v2").post("sell-baazar", data);
	}
}

export enum AccountingStatus {
	DEBTOR = "DEBTOR",
	CREDITOR = "CREDITOR",
}

export enum AccountingSubject {
	SETTLEMENT = "SETTLEMENT",
	CHARGE_RIAL_CREDIT = "CHARGE_RIAL_CREDIT",
	TRANSFER_BAAZAR = "TRANSFER_BAAZAR",
	TRANSFER_BAAZAR_WAGE = "TRANSFER_BAAZAR_WAGE",
	SELL_BAAZAR = "SELL_BAAZAR",
	SELL_BAAZAR_WAGE = "SELL_BAAZAR_WAGE",
	BUY_BAAZAR = "BUY_BAAZAR",
	BUY_BAAZAR_WAGE = "BUY_BAAZAR_WAGE",
	CLEARING_CREDIT_BAAZAR = "CLEARING_CREDIT_BAAZAR",
	MANUALLY_UPDATE_BAAZAR = "MANUALLY_UPDATE_BAAZAR",
	MANUALLY_MANAGE_GOD_WALLET = "MANUALLY_MANAGE_GOD_WALLET",
	BUY_CREDIT_BAAZAR_DEPOSIT = "BUY_CREDIT_BAAZAR_DEPOSIT",
	BUY_CREDIT_BAAZAR_DEBT = "BUY_CREDIT_BAAZAR_DEBT",
	BLOCK_OR_UNBLOCK_GOLD = "BLOCK_OR_UNBLOCK_GOLD",
	SELL_BAAZAR_CREDIT_TIMED_OUT = "SELL_BAAZAR_CREDIT_TIMED_OUT",
	SELL_BAAZAR_AUTOMATICALLY = "SELL_BAAZAR_AUTOMATICALLY",
	MANUALLY_UPDATE_RIAL = "MANUALLY_UPDATE_RIAL",
}

export type FinancialType = {
	id: string;
	rialAmount?: number;
	baazarAmount?: number;
	description?: string;
	createdDate: number;
	lastModifiedDate: number;
	accountingStatus: AccountingStatus;
	accountingSubject: AccountingSubject;
	accountingSubjectDescription?: string;
	currentRialAmount: number;
	currentBaazarAmount: number;
};

const FinancialService = new FinancialServiceProvider();

export default FinancialService;
